import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { Button, Table, Pagination, message, Radio, DatePicker } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class PlayerStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            kind: 0,
            date: [
                moment().subtract(1, 'days'),
                moment(),
            ],
        },
        data: [], // 表格数据
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/union_club_user_statistic_all", {
                params: {
                    ...this.state.queryParams,
                    begin_time: this.state.queryParams.kind === 2 ?
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000
                        :
                        undefined
                    ,
                    end_time: this.state.queryParams.kind === 2 ?
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000
                        :
                        undefined
                    ,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/union_club_user_statistic_all_export", {
                params: {
                    ...this.state.queryParams,
                    begin_time: this.state.queryParams.kind === 2 ?
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000
                        :
                        undefined
                    ,
                    end_time: this.state.queryParams.kind === 2 ?
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000
                        :
                        undefined
                    ,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState(
            { queryParams: { ...this.state.queryParams, page: 1, [key]: value } },
            () => this.fetchData()
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Radio.Group
                        value={this.state.queryParams.kind}
                        buttonStyle="solid"
                        onChange={(e) =>
                            this.handleSetQueryParamsData("kind", e.target.value)
                        }
                    >
                        <Radio.Button value={0}>
                            {this.props.language["yesterday"]}
                        </Radio.Button>
                        <Radio.Button value={1}>
                            {this.props.language["sevenDay"]}
                        </Radio.Button>
                        <Radio.Button value={2}>
                            {this.props.language["customTime"]}
                        </Radio.Button>
                    </Radio.Group>
                    {this.state.queryParams.kind === 2 &&
                        <DatePicker.RangePicker
                            value={this.state.queryParams.date}
                            onChange={(e) => this.handleSetQueryParamsData("date", e)}
                            allowClear={false}
                        />
                    }
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["playerId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/player_detail/${item.uid}/${item.club_id}`}>
                                    {item.uid || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerName"]}
                            dataIndex="user_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["belongUnion"]}
                            dataIndex="union_name"
                        />
                        {Cookie.get("isDirect") === 'false' ?
                            <Table.Column
                                align="center"
                                title={this.props.language["belongClubId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link to={`/club_detail/${item.club_id}`}>{item.club_id || ''}</Link>
                                )}
                            />
                            :
                            <Table.Column
                                align="center"
                                title={this.props.language["belongProxyId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link to={`/player_detail/${item.club_owner_id}/${item.club_id}`}>{item.club_owner_id || ''}</Link>
                                )}
                            />
                        }
                        {Cookie.get("isDirect") === 'false' ?
                            <Table.Column
                                align="center"
                                title={this.props.language["belongClub"]}
                                dataIndex="club_name"
                            />
                            :
                            <Table.Column
                                align="center"
                                title={this.props.language["belongProxy"]}
                                dataIndex="club_owner_name"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["joinTableNumber"]}
                            dataIndex="match_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["handCardNumber"]}
                            dataIndex="hands_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerProfit"]}
                            dataIndex="profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFee"]}
                            dataIndex="fee_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insurance"]}
                            dataIndex="ins_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceInvestmentAmount"]}
                            dataIndex="ins_buy_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboysProfit"]}
                            dataIndex="cb_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyBettingAmount"]}
                            dataIndex="cb_buy_in_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["joinTableNumberStatistics"]}
                            dataIndex="match_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["handNumberStatistics"]}
                            dataIndex="hands_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["profitStatistics"]}
                            dataIndex="profit_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeStatistics"]}
                            dataIndex="fee_sum_detail"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceStatistics"]}
                            dataIndex="ins_profit_sum_detail"
                        />
                    </Table>
                </div>
            </div>
        );
    }
}
